import { render, staticRenderFns } from "./codeExplain.vue?vue&type=template&id=c1248894&scoped=true"
import script from "./codeExplain.vue?vue&type=script&lang=js"
export * from "./codeExplain.vue?vue&type=script&lang=js"
import style0 from "./codeExplain.vue?vue&type=style&index=0&id=c1248894&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1248894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1248894')) {
      api.createRecord('c1248894', component.options)
    } else {
      api.reload('c1248894', component.options)
    }
    module.hot.accept("./codeExplain.vue?vue&type=template&id=c1248894&scoped=true", function () {
      api.rerender('c1248894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/codeExplain.vue"
export default component.exports